import types from './dashboardTypes';

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.RECEIVE_DASHBOARD: {
            if (!action.payload.dashboard) return state;
            return {
                ...state,
                ...action.payload.dashboard,
            };
        }
        default:
            return state;
    }
};
